import axios, { AxiosResponse } from 'axios'
import { EntitySingleResponseUser, User, UserCreationRequest } from 'cs.node.utils/csapi/system'
import { checkResponseStatus } from './Utils'

export const changeLanguage = async(language:string) => {
    try {
        const response = await axios.patch('api/users/me/change-language', {language})
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

export const getUsers = async()=>{
    try {
        const response: AxiosResponse<{users: User[]},any> = await axios.get('api/users')
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

export const patchUser = async(id:string, userUpdate:Partial<User>)=>{
    try {
        const response: AxiosResponse<EntitySingleResponseUser,any> = await axios.patch(`api/users/${id}`, userUpdate)
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

export const changePassword = async(password:string) => {
    try {
        const response = await axios.patch('api/users/me/change-password', {password})
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

export const uploadAvatar = async(userId:string|undefined, formData: FormData) =>{
    try {
        const response: AxiosResponse<EntitySingleResponseUser,any> = await axios.post(`api/users/${userId}/avatar`, formData)
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

export const createUser = async(userCreate:UserCreationRequest)=>{
    try {
        const response: AxiosResponse<EntitySingleResponseUser,any> = await axios.post(`api/users`, userCreate)
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}

export const getUserProfile = async()=>{
    try {
        const response: AxiosResponse<User,any> = await axios.get(`api/users/me`)
        return response.data
    } catch(error:any) {
        checkResponseStatus(error)
        throw error
    }
}